

<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>

<div *ngIf="!containsError">
    <div class="pageHeader" id="transactionsListHeader">List of Transactions</div>

  <div *ngIf="noTranSel != null && noTranSel.length >0" class="no-trans-selected">
    <li class="error-list-msg">{{noTranSel}}</li>

  </div>

    <div *ngIf="responseTransList" class="u-scroll-x">
    <div class="download-button">
      <div class="select-style">
        <fm-select
          [options]="pageView"
          placeholder="Choose"
          [(ngModel)]="selectedPageView"></fm-select>
      </div>
      <button fmButton class="ok-button" type="button" [small]="true" label="Ok" (click)='pageViewAction(dt)'></button>
     </div>
     <br><br>
  <fm-table #dt [columns]="displayCols" [value]="responseTransList"
              [paginator]="true" [rows]="10"
              [compressed]="true" [autoLayout]="true"
              [rowsPerPageOptions]="[10,25,50]" [enableTableEntryTotal]="true">
      <ng-template fmTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" class="row-selection">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template fmTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td class="td-content" *ngFor="let col of columns">

            <span *ngIf="col.header==='Delete ?' && (isAdminrole === 'true' || internalUpdateRoleFlag === 'true' || externalUpdateRoleFlag === 'true')">
                <fm-checkbox #deleteCheckbox [value]="rowData" [disabled]=" ((rowData['transStatus']) !== 'Pending' && (rowData['transStatus']) !='Pending For Approval')" ></fm-checkbox>

            </span>
            <span *ngIf="col.header==='Loan Number'">
              <a  (click)="showLoanDetails(rowData)"   class="detail-link">{{rowData[col.field]}} </a>
            </span>
            <span *ngIf="col.header==='Trans ID'">
              <a  (click)="showTransactionDetails(rowData)"   class="detail-link">{{rowData[col.field]}} </a>
            </span>
              <span *ngIf="col.header!=='Loan Number' && col.header!=='Trans ID' && col.header!=='Trans Amount'"> {{rowData[col.field]}}</span>
              <span class="column-right-align" *ngIf="col.header==='Trans Amount'"> {{ rowData[col.field] | currency }}</span>

          </td>
        </tr>
      </ng-template>
    </fm-table>
  </div>
  <span></span>

  <div class="u-mb-150">
    <div *ngIf="(this.isAdminrole === 'true') || (this.internalUpdateRoleFlag === 'true') || (this.externalUpdateRoleFlag === 'true')">
      <button fmButton type="submit" [primary]="true" [small]="true" label="Select All" (click)="selectAll()"
              class="buttonmargin"></button>

      <button fmButton type="button" [primary]="true" label="Unselect All" (click)="unSelectAll()" [small]="true"
              class="buttonmargin"></button>

      <button fmButton type="button" (click)="deleteTransactions()" [primary]="true" label="Delete" [small]="true"
              class="buttonmargin"></button>
    </div>
    <button fmButton type="button" [primary]="true" label="Cancel" [small]="true" (click)="onCancel()"
            class="buttonmargin"></button>

  </div>

</div>
